import { Modal } from "shared/ui/components/Modal";

import { CalculatorForm } from "components/CalculatorForm";

import CrossIcon from "assets/icons/cross.svg?react";

import styles from "./CalculatorModal.module.scss";

const CalculatorModal = ({
  open,
  submitLoading,
  isAuthenticated,
  variant,
  defaultValues,
  isSonderAfaForced,
  onCalculationClick,
  onModalOpen,
  onClose,
}: any) => (
  <Modal
    className={styles.modal}
    portalClassName={styles.portal}
    open={open}
    onClose={onClose}
  >
    <div className={styles.header}>
      <div className={styles.iconWrapper} onClick={onClose}>
        <CrossIcon className={styles.icon} />
      </div>
    </div>
    <CalculatorForm
      submitLoading={submitLoading}
      isAuthenticated={isAuthenticated}
      variant={variant}
      defaultValues={defaultValues}
      isSonderAfaForced={isSonderAfaForced}
      onCalculationClick={onCalculationClick}
      onModalOpen={onModalOpen}
    />
  </Modal>
);

export default CalculatorModal;
